import React from "react";

const Scientific = () => {
  return <div>Scientific Requirements</div>;
};

export default Scientific;
